














































































































































































































































































import ModalVehicleCalibration from './ModalVehicleCalibration.vue';
import SimpleMap from '../../core/components/SimpleMap.vue';
import ListEvents from '../../core/components/ListEvents.vue';
import Loading from 'vue-loading-overlay';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    matchedIndexIdInArray,
    getUniqueId,
    getDateFromTimestamp,
    getHourFromTimestamp,
    formatDate,
    splitStringByIndex,
    getMaxDateFromList,
    getMinDateFromList,
    openTravelWithParameter,
    getOnlyDateFromTimestamp,
    removeItemsFromList,
    parseFloatNumber,
    booleanFormatter,
    timestampToTime,
    itemsPerPageOptionsTable
} from '../../core/utils';
import { formattedDate } from '../../core/utils/table-formatters';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    SimpleTable,
    Button,
    Combobox,
    LDialogOld,
    PlusEyeButtons,
    Breadcrums,
    Input,
    CloseConfirmationModal
} from '../../core/components';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import HourSelector from '../../core/components/HourSelector.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import { config } from 'rxjs';
import moment from 'moment';
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import vColumnsResizable from '../../../plugins/vue-columns-resizable'
exportingInit(Highcharts);

@Component({
    directives: {
        'v-columns-resizable': vColumnsResizable,
    },
    components: {
        Loading,
        SimpleTable,
        Combobox,
        Button,
        LDialogOld,
        DatePickerSingle,
        DatePickerRange,
        ModalVehicleCalibration,
        HourSelector,
        DeleteConfirmation,
        Input,
        ListEvents,
        highcharts: Chart
    }
})
export default class ModalViewSegments extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() segmentInfo: object | null;
    @Prop() visible: boolean;
    @Prop() vehicleID: number | null;
    @Prop({ default: false }) pendingSegment: boolean;
    @Prop({ default: -1 }) companyId: number;
    itemsPerPageOptions: Array<number> = itemsPerPageOptionsTable;

    modalTitle: string = 'Ver segmento';
    noteDescription: string = '';
    dateRangeSelected: any = [];
    vehicleVariables: Array<object> = [];
    visibleModalVehicleCalibration: boolean = false;
    patchCalibration: object | null = null;
    itemsHumidityCalibrationPeriods: Array<object> = [];
    notesList: Array<object> = [];
    chartOptions: object = {};
    headersHumidityCalibrationPeriods: Array<object> = [
        {
            text: 'Variable',
            value: 'variable',
            sortable: true
        },
        {
            text: 'Fecha Inicio',
            value: 'start_date',
            width: '200px',
            sortable: true
        },
        {
            text: 'Fecha Fin',
            value: 'end_date',
            width: '200px',
            sortable: true
        },
        // {
        //     text: 'Factor calibración',
        //     value: 'cal_factor',
        //     align: 'center',
        //     formatter: parseFloatNumber,
        //     sortable: true,
        // },
        {
            text: 'Factor calibración (%)',
            align: 'center',
            value: 'custom_cal_factor',
            sortable: true
        }
    ];

    calibrationToDelete: object = {};
    loadingCalibrations: boolean = false;
    itemsCalibrations: Array<object> = [];
    headersCalibrations: Array<object> = [
        {
            text: 'Humedad (medida)',
            align: 'center',
            value: 'humidity',
            class: 'pa-0'
        },
        {
            text: 'Peso (medido)',
            align: 'center',
            value: 'weight',
            class: 'pa-0'
        },
        {
            text: 'Humedad (máquina)',
            align: 'center',
            value: 'measured_humidity',
            class: 'pa-0'
        },
        {
            text: 'Peso (máquina)',
            align: 'center',
            value: 'measured_weight',
            class: 'pa-0'
        },
        {
            text: 'Area',
            align: 'center',
            value: 'area',
            class: 'pa-0'
        },
        {
            text: 'Telemetria',
            align: 'center',
            formatter: this.parseBoolean,
            value: 'using_telemetry',
            class: 'pa-0'
        },
        {
            text: 'Fecha Inicio',
            align: 'center',
            value: 'start_date',
            formatter: this.dateFormatter,
            width: '300px'
        },
        {
            text: 'Fecha Fin',
            align: 'center',
            value: 'end_date',
            formatter: this.dateFormatter,
            width: '300px'
        }
    ];
    ranchName: string = '-';
    calibratedPerformance: any = 0;
    uncalibratedPerformance: any = 0;
    calibratedHumidity: any = 0;
    uncalibratedHumidity: any = 0;

    segmentError: any = null;

    @Watch('pendingSegment')
    observableLoadingData(value) {
        let self = this;
        if (!value) {
            setTimeout(() => {
                self.loadSegmentData();
            }, 0);
        } else {
            this.loadingCalibrations = true;
            this.loadingHumidityCalibrationPeriods = true;
        }
    }

    //delete modal
    confirmationDelete: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';

    deleteCalibration(calibrationToDelete) {
        this.calibrationToDelete = calibrationToDelete;
        this.showDeleteConfirmationDialog('Eliminar Calibración', '¿Está seguro que desea eliminar esta calibración?');
    }

    deleteAction(value) {
        if (value) {
            this.removeCalibration();
        } else {
            this.confirmationDelete = false;
        }
    }

    removeCalibration() {
        let self = this;
        this.loadingCalibrations = true;
        InsuranceServices.deleteCalibration(this.calibrationToDelete['id'])
            .then(response => {
                let msg = '';
                if (response && response.data && response.data.message) {
                    msg = response.data.message;
                } else {
                    msg = 'Calibración Eliminada con éxito';
                }
                self.$_successDeleteRecipients(msg);
                self.itemsCalibrations = removeItemsFromList(self.itemsCalibrations, [self.calibrationToDelete], 'id');
                self.loadingCalibrations = false;
            })
            .catch(error => {
                this.showMsgError(error);
                self.loadingCalibrations = false;
            });
    }

    showMsgError(error) {
        let self = this;
        let msg = '';
        if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message;
        } else {
            msg = 'Ocurrió un error';
        }
        this.$_errorAddFilter(msg);
    }

    setCharts(res) {
        //  console.log("set charts", res);
        let data = res['calibration_periods'];
        let pointsPerformance: any = [];
        let pointsHumidity: any = [];

        if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
                let point = data[i];
                let itemToPush: any = [
                    {
                        x: timestampToTime(point['start_date']),
                        y: Number(parseFloatNumber(point['cal_factor_percent']))
                    },
                    {
                        x: timestampToTime(point['end_date']),
                        y: Number(parseFloatNumber(point['cal_factor_percent']))
                    }
                ];
                if (point['variable'] === 'Rendimiento') {
                    pointsPerformance = [...pointsPerformance, ...itemToPush];
                } else {
                    pointsHumidity = [...pointsHumidity, ...itemToPush];
                }
            }
        }

        let series = [
            {
                pointWidth: 20,
                data: pointsPerformance,
                name: 'Rendimiento',
                type: 'line',
                yAxis: 0,
                dataLabels: {
                    enabled: true,
                    valueDecimals: 3,
                    formatter: function() {
                        return this.point.y + '%';
                    }
                }
            },
            {
                type: 'line',
                name: 'Humedad',
                yAxis: 1,
                pointWidth: 20,
                data: pointsHumidity,
                dataLabels: {
                    enabled: true,
                    formatter: function() {
                        return this.point.y + '%';
                    }
                }
            }
        ];

        // debugger;

        // categories = [1, 1.5, 1.9];
        this.chartOptions = {
            time: {
                useUTC: false
            },
            xAxis: {
                type: 'datetime',
                labels: {
                    format: '{value:%e-%m-%y %H:%M:%S}',
                    style: {
                        width: 80
                    }
                }
            },
            yAxis: [
                {
                    title: {
                        text: 'Rendimiento'
                    }
                },
                {
                    title: {
                        text: 'Humedad'
                    },
                    opposite: true
                }
            ],
            chart: {
                type: 'column',
                zoomType: 'x'
            },
            title: {
                text: ''
            },
            series: series
        };
    }

    showDeleteConfirmationDialog(title, msgBody) {
        this.deleteModalTitle = title;
        this.deleteBody = msgBody;
        this.confirmationDelete = true;
    }

    modifyCalibration(item) {
        this.$set(item, 'isLoading', true);
        this.patchCalibration = JSON.parse(JSON.stringify(item));
        this.visibilityModalCalibration(true);
        this.$set(item, 'isLoading', false);
    }

    addNewCalibration(newCalibration) {
        this.loadingCalibrations = true;
        let oldItems = this.itemsCalibrations;
        this.itemsCalibrations = [];
        oldItems.push(newCalibration);
        setTimeout(() => {
            this.itemsCalibrations = oldItems;
            this.loadingCalibrations = false;
        }, 1000);
    }

    updateCalibration(updatedCalibration) {
        this.loadingCalibrations = true;
        let indexIdToPatch = matchedIndexIdInArray(this.itemsCalibrations, updatedCalibration['id']);
        if (indexIdToPatch !== -1) {
            this.$set(this.itemsCalibrations[indexIdToPatch], 'date', updatedCalibration['date']);
            this.$set(
                this.itemsCalibrations[indexIdToPatch],
                'weight_calibration_factor',
                updatedCalibration['weight_calibration_factor']
            );
            this.$set(
                this.itemsCalibrations[indexIdToPatch],
                'humidity_calibration_factor',
                updatedCalibration['humidity_calibration_factor']
            );
            this.$set(this.itemsCalibrations[indexIdToPatch], 'weight_variable', updatedCalibration['weight_variable']);
            this.$set(
                this.itemsCalibrations[indexIdToPatch],
                'humidity_variable',
                updatedCalibration['humidity_variable']
            );
            this.$set(this.itemsCalibrations[indexIdToPatch], 'location', updatedCalibration['location']);
            this.$set(this.itemsCalibrations[indexIdToPatch], 'work_width', updatedCalibration['work_width']);
            this.$set(this.itemsCalibrations[indexIdToPatch], 'operator', updatedCalibration['operator']);
            this.$set(this.itemsCalibrations[indexIdToPatch], 'harvest_type', updatedCalibration['harvest_type']);
            this.$set(this.itemsCalibrations[indexIdToPatch], 'function', updatedCalibration['function']);
            this.$set(this.itemsCalibrations[indexIdToPatch], 'comments', updatedCalibration['comments']);
            this.$set(
                this.itemsCalibrations[indexIdToPatch],
                'calibration_passes',
                updatedCalibration['calibration_passes']
            );
        }
        this.loadingCalibrations = false;
    }

    visibilityModalCalibration(value) {
        this.visibleModalVehicleCalibration = value;
        if (!value) {
            this.patchCalibration = {};
        }
    }

    parseNumber(value) {
        return parseFloatNumber(value);
    }

    dateFormatter(value) {
        return formattedDate(value);
    }

    parseBoolean(value) {
        return booleanFormatter(value);
    }

    //LoadingDialog
    pendingRequest: boolean = false;
    msgLoadingDialog: string = '';
    errorResponse: any = {};
    successPost: boolean | null = null;

    loadingHumidityCalibrationPeriods: boolean = false;
    loadingPerformanceCalibrationPeriods: boolean = false;

    showLoadingDialog(msg) {
        this.pendingRequest = true;
        this.successPost = null;
        this.msgLoadingDialog = msg;
    }

    resetVariables() {
        this.ranchName = '';
        this.calibratedPerformance = 0;
        this.uncalibratedPerformance = 0;
        this.calibratedHumidity = 0;
        this.uncalibratedHumidity = 0;
    }

    closeModalLoadingDialog() {
        this.pendingRequest = false;
        this.successPost = null;
        this.msgLoadingDialog = '';
        // this.enableScrollLoadingDialog();
    }

    showSuccessLoadingDialog(msg) {
        this.pendingRequest = true;
        this.successPost = true;
        this.msgLoadingDialog = msg;

        setTimeout(() => {
            this.closeModalLoadingDialog();
            this.closeModal();
        }, 1000);
    }

    showCatchLoadingDialog(error) {
        let self = this;
        self.successPost = false;
        self.errorResponse = {};
        self.msgLoadingDialog = '';
        if (error && error.response && error.response.data && error.response.data.message) {
            self.msgLoadingDialog = error.response.data.message;
        } else {
            self.msgLoadingDialog = 'Ocurrió un error';
            self.errorResponse = error.response.data;
        }
    }

    @Emit()
    closeModal() {
        this.resetVariables();
    }

    mounted() {
        let self = this;
        this.$nextTick(() => {
            self.showLoadingDialog('Buscando información del segmento...');
            self.getVehicleVariables();
            self.assignPropertiesData();
        });
    }

    getVehicleVariables() {
        this.vehicleVariables = [];
        if (this.vehicleID) {
            InsuranceServices.getVehiclesVariables(this.vehicleID)
                .then(res => {
                    this.vehicleVariables = res['variable_configurations'];
                })
                .catch(err => {
                    this.vehicleVariables = [];
                });
        }
    }

    assignPropertiesData() {
        //    this.calibrationOptions = this.$_getInsuranceProperties['calibration_functions'];
    }

    changeDateRange(value) {
        this.dateRangeSelected = value;
    }

    get isPatch() {
        return this.segmentInfo !== null ? true : false;
    }

    getTooltipCalFactor(item) {
        return item['cal_factor'] + '<br> ' + item['cal_factor_percent'] + '(%)';
    }

    loadSegmentData() {
        this.segmentError = null;
        if (this.segmentInfo !== null) {
            if (this.segmentInfo && this.segmentInfo['error']) {
                this.segmentError = this.segmentInfo['error'];
            } else {
                let segmentStartDate = this.segmentInfo['start'];
                let segmentEndDate = this.segmentInfo['end'];
                this.changeDateRange([segmentStartDate, segmentEndDate]);
                this.ranchName = this.segmentInfo['ranch'] ? this.segmentInfo['ranch']['name'] : '-';
                for (let index = 0; index < this.segmentInfo['calibration_periods'].length; index++) {
                    const calibration_period = this.segmentInfo['calibration_periods'][index];
                    let factors = {
                        cal_factor: calibration_period['cal_factor'],
                        cal_factor_percent: calibration_period['cal_factor_percent']
                    };
                    calibration_period['custom_cal_factor'] = factors;
                }
                this.itemsHumidityCalibrationPeriods = this.segmentInfo['calibration_periods'];
                this.itemsCalibrations = this.segmentInfo['calibration_passes'];
                this.notesList = this.segmentInfo['notes'];
                this.calibratedPerformance = parseFloatNumber(this.segmentInfo['performance']);
                this.uncalibratedPerformance = parseFloatNumber(this.segmentInfo['uncalibrated_performance']);
                this.calibratedHumidity = parseFloatNumber(this.segmentInfo['humidity']);
                this.uncalibratedHumidity = parseFloatNumber(this.segmentInfo['uncalibrated_humidity']);
                this.loadingCalibrations = false;
                this.loadingHumidityCalibrationPeriods = false;
                this.changeDateRange([this.segmentInfo['start'], this.segmentInfo['end']]);
                this.setCharts(this.segmentInfo);
            }
            //   this.setHumidityCalibrationsPeriods(this.segmentInfo['humidity_calibration_periods']);
        }
    }

    //    setHumidityCalibrationsPeriods(items){
    //        this.itemsHumidityCalibrationPeriods = items;
    //        this.loadingHumidityCalibrationPeriods = false;
    //    }

    viewSegmentInTravel() {
        if (this.segmentInfo !== null && this.vehicleID !== null && this.companyId !== -1) {
            let startDate = this.segmentInfo['start'];
            let endDate = this.segmentInfo['end'];
            let vId = this.vehicleID;
            let companyId = this.companyId;

            openTravelWithParameter(startDate, endDate, [vId], companyId);
        }
    }
}
